// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyC_NoNhF4tWz0ot9BKoNPX562TFnaIKOwI",
  authDomain: "rockpaperrunway-660f0.firebaseapp.com",
  projectId: "rockpaperrunway-660f0",
  storageBucket: "rockpaperrunway-660f0.firebasestorage.app",
  messagingSenderId: "901116855006",
  appId: "1:901116855006:web:493e98ad9fb33b240a784f",
  measurementId: "G-9FZ1V8CX38"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export default app;